function formatSumWithSymbol(sum = 0) {
  return `${sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}  ₽`;
}

export default formatSumWithSymbol;
